<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">单位名称</div>
          <div class="field">
            <el-input v-model.trim="query.comname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目员</div>
          <div class="field">
            <el-input v-model.trim="query.projectCusername" clearable></el-input>
            <el-button type="primary" size="mini" style="margin-left: 4px" @click="queryChangeName('projectCusername', loginUser.username)">仅自己</el-button>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">业务员</div>
          <div class="field">
            <el-input v-model.trim="query.ptcUsername" clearable></el-input>
            <el-button type="primary" size="mini" style="margin-left: 4px" @click="queryChangeName('ptcUsername', loginUser.username)">仅自己</el-button>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">报价状态</div>
          <div class="field">
            <el-select
              v-model="query.projectbjstatus"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in projectbjstatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button
              type="primary"
              @click="showButton = !showButton"
              >{{ showButton ? "收起" : "展开" }}</el-button
            >
          </div>
        </div>
      </div>
      <div>
        <el-collapse-transition>
          <div v-show="showButton" style="padding: 10px">
            <el-radio-group v-model="areaid" @change="getPageList">
              <el-radio-button
                v-for="item in this.areaList"
                :key="item.dptareacode"
                :label="item.dptareacode"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    
    <vxe-table
        border
        highlight-hover-row
        align="content-center"
        :loading="loading"
        :data="list">
        <vxe-table-column header-align="center" title="报价日期" width="140">
          <template v-slot="{ row }">
            <div style="display: flex;flex-direction: column;align-items: center;">
              <span :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}">
                {{ formatBegTime(row.prsbjbegtime) }}
              </span>
              <span :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}">
                {{ formatDay(row.prsbjbegtime) }}
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="prsbjbegtime" title="开始时间" width="80">
          <template v-slot="{ row }">
            <div style="width: 100%;text-align:center" :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}">{{ formatTime(row.prsbjbegtime) }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="sex" title="结束时间" width="80">
          <template v-slot="{ row }">
            <div style="width: 100%;text-align:center" :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}"> {{ formatTime(row.prsbjendtime) }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="projectcode" title="项目编号" width="160">
          <template v-slot="{ row }">
            <span :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}"> {{ row.projectcode }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="projectname" title="项目名称" width="240">
          <template v-slot="{ row }">
            <span :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}"> {{ row.projectname }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="prsflgdesc" title="交易方式" >
          <template v-slot="{ row }">
            <div style="width: 100%;text-align:center" :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}">  {{ row.prsflgdesc }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="sex" title="业务员" >
          <template v-slot="{ row }">
             <div style="width: 100%;text-align:center" :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}">  {{ row.projectsusername }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="sex" title="项目员" >
          <template v-slot="{ row }">
            <div style="width: 100%;text-align:center" :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}">  {{ row.projectrecusername }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="projectlimitamtdesc" title="预算金额（元）" width="120">
          <template v-slot="{ row }">
            <div style="width: 100%;text-align:right" :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}">  {{ row.projectlimitamtdesc }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column header-align="center" field="comfullname" title="采购人" width="240">
          <template v-slot="{ row }">
            <span :style="{color: isCurrentDay(row.prsbjbegtime) ? 'red': ''}">  {{ row.comfullname }}</span>
          </template>
        </vxe-table-column>
    </vxe-table>
    <vxe-pager
        :loading="loading"
        :page-sizes="[5, 10, 20, 50, 100]"
        :current-page="query.currentPage"
        :page-size="query.pageSize"
        :total="query.total"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange"
      ></vxe-pager>
  </Container>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from "../common/menuBtn"
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
import dayjs  from 'dayjs'
import amount from '../common/amount'
import common from '@/mixin/common'
import { mapGetters } from 'vuex'
export default {
  name: 'pbrIndex',
  mixins: [common],
  data() {
    return {
      menuid: this.$route.query.menuid,
      btn: {},
      list: [],
      comform: false,
      project: {},
      com: {},
      loading:true,
      areaList: [],
      areaid: 0, //查询地区id
      showButton: true,
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        userid: this.$store.getters.loginUser.userid,
        comid: this.$store.getters.loginUser.comid,
        comtype: this.$store.getters.loginUser.comtype,
        total: 0,
        limit: 20,
        offset: 0,
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      projectbjstatus: [
        { label: "全部", value: "0" },
        { label: "未报", value: "1" },
        { label: "已报", value: "2" },
      ],
      roles: [],
      dialogList: []
    }
  },
  async activated() {
    await this.getPageList()
    await this.getareaList()
  },
  async mounted() {
    await this.getPageList()
    await this.getareaList()
  },
  components: { MenuBtn, vggrid },
  methods: {
    filterCurrentDay (project) {
      const beforeDay = dayjs().second(0).minute(0).hour(0)
      const afterDay = dayjs().day(beforeDay.day() + 1).second(0).minute(0).hour(0)
      return dayjs(project.prsbjbegtime).isAfter(beforeDay) && dayjs(project.prsbjbegtime).isBefore(afterDay)
    },
    filterAfterDay (project) {
      const currentDay = dayjs().second(0).minute(0).hour(0)
      return dayjs(project.prsbjbegtime).isAfter(currentDay)
    },
    isCurrentDay(time = '') {
      if (!time) return false
      const beforeDay = dayjs().second(0).minute(0).hour(0)
      const afterDay = dayjs().day(beforeDay.day() + 1).second(0).minute(0).hour(0)
      return dayjs(time).isAfter(beforeDay) && dayjs(time).isBefore(afterDay)
    },
    queryChangeName (name, val) {
      this.$set(this.query, name, val)
      // this.query[name] = val
    },
     //获取地区list
    async getareaList() {
      let res = await request({
        method: "get",
        url: "/xtgl/dpt/getDptareaList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.areaList = res.filter((e) => {
        return +e.dptareause === 1;
      });
      this.areaList.unshift({
        dptareacode: 0,
        label: "全部",
      });
    },
    formatBegTime (time = '') {
      const d = dayjs(time)
      return `${d.year()}年${d.month()+1}月${d.date()}日`
    },
    formatTime(time=''){
      return dayjs(time).format('HH:mm')
    },
    formatDay (time = ''){
      const d = dayjs(time)
      let de = ''
      switch (d.day()) {
        case 0:
          de ='星期日'
          break;
        case 1:
          de ='星期一'
          break;
        case 2:
          de ='星期二'
          break; 
        case 3:
          de ='星期三'
          break; 
        case 4:
          de ='星期四'
          break;
        case 5:
          de ='星期五'
          break; 
        case 6:
          de ='星期六'
          break;
      }
      return de
    },
    async handlePageChange({ currentPage, pageSize }) {
      this.query.offset = pageSize * (currentPage - 1)
      this.query.limit = pageSize
      this.query.currentPage = currentPage
      this.query.pageSize = pageSize
      await this.getPageList()
    },
    async getPageList () {
      this.loading = true
      this.query.isJJorTB = 1
      this.query.cosid = this.$store.getters.loginUser.cosid
      this.query.areaid = this.areaid
      let res = await request({
        method: 'get',
        url: '/xmgl/project/getQuotationPlanList',
        params: this.query
      })
      this.list = [].concat(res.list)
      if (res.list.length > 0) {
        const currentDayList = res.list.filter((item) => {
          return this.filterCurrentDay(item)
        }).sort((prev, next)=>{
          return +new Date(prev.prsbjbegtime)  - +new Date(next.prsbjbegtime)
        })
        const afterDayList = res.list.filter((item) => {
          return this.filterAfterDay(item) && !this.filterCurrentDay(item)
        }).sort((prev, next)=>{
          return +new Date(prev.prsbjbegtime)  - +new Date(next.prsbjbegtime)
        })
        const otherDay = res.list.filter((item) => {
          return !this.filterCurrentDay(item) && !this.filterAfterDay(item)
        })
        this.list = [].concat(currentDayList).concat(afterDayList).concat(otherDay)
      }
      // this.list = res.list
      res.list.forEach(e => {
        e.projectisinviteCN = +e.projectisinvite === 1 ? '邀请' : '公开'
        e.projectlimitamtdesc = e.projectlimitamt ? utils.comdify(e.projectlimitamt) : e.projectlimitamt
      });
      this.query.total = res.count[0].count
      this.loading = false
    },
    async getModel(d) {
      let res = await request({
        method: 'get',
        url: '/xmgl/project/findProjectById',
        params: { projectid: d[0].projectid }
      })
      this.project = res
    },
    async getBJList() {
      let model = {}
      this.project = {}
      let res = await request({
        url: '/xmgl/pbr/getPbrListByProjectName',
        method: "get",
        params: this.query
      })
      // if (+this.project.projectpricelistflag === 0 && +this.$store.getters.loginUser.comtype === 3) {
      //   res = res.filter(e => {
      //     return +e.pbrcomid === +this.$store.getters.loginUser.comid
      //   })
      // }
      res.map(e => {
        e.psuoffertime = dayjs(e.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
      })
      if (res.length > 0) {
        await this.getModel(res)
      }
      this.dialogList = this.Sortbycomid(res)
    },
    Sortbycomid(beforeData) {
      let tempArr = [], afterData = []
      for (let i = 0; i < beforeData.length; i++) {
        if (tempArr.indexOf(beforeData[i].pbrcomid) === -1) {
          this.project.projectquotationmode = beforeData[i].projectquotationmode
          this.project.prsflg = beforeData[i].prsflg
          afterData.push({
            pbrcomid: beforeData[i].pbrcomid,
            projectname: beforeData[i].projectname,
            projectcode: beforeData[i].code,
            prsbjtimes: beforeData[i].prsbjtimes,
            projectquotationmode: beforeData[i].projectquotationmode,
            origin: [beforeData[i]]
          });
          tempArr.push(beforeData[i].pbrcomid);
        } else {
          for (let j = 0; j < afterData.length; j++) {
            if (afterData[j].pbrcomid == beforeData[i].pbrcomid) {
              afterData[j].origin.push(beforeData[i]);
              // afterData[j].origin.sort((a,b) => {
              //   return Number(a.pbramt) - Number(b.pbramt)
              // })
              break;
            }
          }
        }
      }
      return afterData
    },
    init() {
      this.query = {
        total: 0,
        limit: 20,
        offset: 0,
        comtype: ''
      }
    },
    async cellClick(row) {
      this.com = row.row
    },
    async viewProject(row) {
      this.com = row.row
      this.$router.push({ name: 'comView', params: { comid: this.com.comid, innerbtn: this.btn.inner } })
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1)
      this.query.limit = page.pageSize
      this.getPageList()
    },
    search() {
      this.query.offset = 0
      this.getPageList()
    },
  },
  filters: {
    longDate(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    newDate(value) {
      return dayjs(value).format('YYYY-MM-DD HH:mm:ss SSS')
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
  },
  components: { amount },
  computed: {
    ...mapGetters(['loginUser']),
    projectQuotationmodeflg() {
      if (+this.project.projectquotationmode === 1) {
        return {
          one: '报价',
          two: '金额报价',
          three: '金额'
        }
      }
      if (+this.project.projectquotationmode === 2) {
        return {
          one: '上浮率报价',
          two: '最高上浮率报价',
          three: '上浮率'
        }
      }
      if (+this.project.projectquotationmode === 3) {
        return {
          one: '下浮率报价',
          two: '最高下浮率报价',
          three: '下浮率'
        }
      }
      if (+this.project.projectquotationmode === 4) {
        return {
          one: '折扣率报价',
          two: '最低折扣率报价',
          three: '折扣率'
        }
      }
      return {
        one: '报价',
        two: '金额报价',
        three: '金额'
      }
    },
    prsName() {
      // 竞拍方案，比选文件
      if (+this.project.prsflg === 1 || +this.project.prsflg === 3) {
        return {
          gys: '竞价单位',
          filename: '竞价方案'
        }
      }
      else if (+this.project.prsflg === 4 || +this.project.prsflg === 5) {
        return {
          gys: '竞拍单位',
          filename: '竞拍方案'
        }
      }
      else if (+this.project.prsflg === 6) {
        return {
          gys: '比选单位',
          filename: '评审文件'
        }
      } else {
        return {
          gys: '竞价单位',
          filename: '竞价方案'
        }
      }
    }
  }
}
</script>
<style lang="scss">
</style>
